import React from "react";
import {connect} from "react-redux";
import DataTable from "../../components/Table";
import {
    addProductAction,
    getPlanTypeList,
    getProductList,
    updateProductStatus,
    updateissuanceType,
    uinSaveHandlerAction
} from "../../store/actions/productConfigActions";
import YesNoRadioButton from "../../components/YesNoRadioButton";
import {toaster} from "../../utils/utils";
import {hasPermission} from "../../components/Permissions";

class ProductConfig extends React.Component {
    initialState = {
        productName: "",
        productCode: "",
        productType: "TERM",
        currentPage: 1,
        editingProductId: null,
        uinDraftById: {},
        savingProductId: null
    }
    constructor(props) {
        super(props);
        this.state = this.initialState;

    }

    componentDidMount() {
        this.props.getPlanTypeList();
        this.props.getProductList();
    }

    setProductName = (pn) => {
        this.setState({
            productName: pn
        })
    }
    setProductCode = (pc) => {
        this.setState({
            productCode: pc
        })
    }
    setProductType = (pt) => {
        this.setState({
            productType: pt
        })
    }

    handleChange = (event) => {
        const planType = event.target.value;
        this.setProductType(planType);
    }
    handleIssuanceConfig = (name,value) => {
        value = value === "yes"? "EASE": "NEWGEN";
        this.props.updateissuanceType(name,value);
    }

    submitConfig = () => {
        if( this.state.productName !== "" && this.state.productCode !== ""){
            this.props.addProductAction(this.state.productName, this.state.productCode, this.state.productType);
        } else {
            toaster("error", "Fill all the fields for adding product");
        }
    }

    handleConfig = (name,value) => {
        value = value === "yes";
        this.props.updateProductStatus(name,value);
    }

    getProductUin = (item) => {
        const value = item.productVersion ?? item.uin;
        return value == null ? "" : String(value);
    }

    sanitizeUin = (value) => {
        return String(value || "").replace(/[^a-zA-Z0-9]/g, "");
    }

    isValidUin = (value) => {
        return /^[a-zA-Z0-9]+$/.test(String(value || ""));
    }

    startEditUIN = (item) => {
        const productId = item.productId;
        this.setState({
            editingProductId: productId,
            uinDraftById: {
                ...this.state.uinDraftById,
                [productId]: this.getProductUin(item)
            }
        });
    }

    stopEditUIN = (productId) => {
        this.setState((prev) => {
            const uinDraftById = { ...prev.uinDraftById };
            delete uinDraftById[productId];
            return {
                editingProductId: null,
                uinDraftById,
                savingProductId: null
            };
        });
    }

    uinChangeHandler = (productId, value) => {
        const nextValue = this.sanitizeUin(value);
        this.setState({
            uinDraftById: {
                ...this.state.uinDraftById,
                [productId]: nextValue
            }
        });
    }

    isUinSaveEnabled = (item) => {
        const productId = item.productId;
        const draft = this.sanitizeUin((this.state.uinDraftById[productId] ?? "").trim());
        const savedUin = this.getProductUin(item).trim();
        if (!this.isValidUin(draft)) {
            return false;
        }
        return draft !== savedUin;
    }

    saveUIN = (item) => {
        const productId = item.productId;
        const uin = this.sanitizeUin((this.state.uinDraftById[productId] ?? "").trim());
        if (!this.isUinSaveEnabled(item) || this.state.savingProductId === productId) {
            return;
        }
        this.setState({ savingProductId: productId });
        this.props.uinSaveHandlerAction(productId, uin)
            .then(() => this.stopEditUIN(productId))
            .catch(() => this.setState({ savingProductId: null }));
    }

    isUinSaveMode = (item) => {
        const productId = item.productId;
        const savedUin = this.getProductUin(item).trim();
        return this.state.editingProductId === productId || savedUin === "";
    }

    renderUinCell = (item) => {
        const productId = item.productId;
        const savedUin = this.getProductUin(item).trim();
        const isSaveMode = this.isUinSaveMode(item);
        const otherRowEditing = this.state.editingProductId != null
            && this.state.editingProductId !== productId;
        const isSaving = this.state.savingProductId === productId;
        const inputValue = this.state.uinDraftById[productId] ?? savedUin;
        const saveEnabled = this.isUinSaveEnabled(item) && !isSaving;

        return (
            <div className="product-config-page__uin-cell">
                <input
                    className="product-config-page__input product-config-page__input--uin"
                    name="uin"
                    value={inputValue}
                    onChange={(e) => this.uinChangeHandler(productId, e.target.value)}
                    placeholder="Enter UIN"
                    disabled={isSaving}
                />
                {isSaveMode ? (
                    <button
                        type="button"
                        className="product-config-page__btn product-config-page__btn--primary"
                        disabled={!saveEnabled}
                        onClick={() => this.saveUIN(item)}
                    >
                        Save
                    </button>
                ) : (
                    <button
                        type="button"
                        className="product-config-page__btn product-config-page__btn--secondary"
                        disabled={otherRowEditing}
                        onClick={() => this.startEditUIN(item)}
                    >
                        Edit
                    </button>
                )}
            </div>
        );
    }

    setComponent = (item,key) => {
        if (key === "uin") {
            return this.renderUinCell(item);
        }
        let status = (key==="status" && item[key] === true) ||(key==="issuanceType"&&  item[key]==="EASE" ) ? "yes" : item[key]===null ? "": "no";
        let keyData = key;
        return (<YesNoRadioButton
            cssClass="product-config-page__toggle"
            handleChange={(name, value) => {
                keyData ==="status"?
                this.handleConfig(name,value) :
                this.handleIssuanceConfig(name,value)  
            }}
            rules={{
                editable: true,
            }}
            yesValue={"yes"}
            noValue={"no"}
            issuanceType={key==="issuanceType"}
            dataname={key==="status"? item.productId : item.productId + " "}
            checked={status}
        />)
    }

    selectPage = (pgNo) => {
        this.setState({
                currentPage: pgNo
            })
    }

    render() {
         let env= localStorage.getItem("envType");
        const showUin = hasPermission("PRODUCT_UIN");
        const dataElements = showUin && env == "DEV" 
            ? ["Product Name", "Product Code", "Plan Type", "UIN", "Configuration", "Issuance Type"]
            : ["Product Name", "Product Code", "Plan Type", "Configuration", "Issuance Type"];
        const dataKeys = showUin && env == "DEV" 
            ? ["productName", "productCode", "productTypeValue", "uin", "status", "issuanceType"]
            : ["productName", "productCode", "productTypeValue", "status", "issuanceType"];
        return (
            <div className="proposal-dashboard product-config-page">
                <div className="proposal-dashboard__header product-config-page__header">
                    <h2 className="proposal-dashboard__title">Product Configuration</h2>
                    <p className="proposal-dashboard__subtitle">
                        Add products and manage configuration settings
                    </p>
                </div>

                <div className="product-config-page__panel">
                    <div className="product-config-page__compact-grid">
                        <div className="product-config-page__field">
                            <label className="product-config-page__label" htmlFor="product-name">
                                Product Name
                            </label>
                            <input
                                id="product-name"
                                className="product-config-page__input"
                                name="productName"
                                value={this.state.productName}
                                onChange={(e) => {
                                    this.setProductName(e.target.value)
                                }}
                                placeholder="Enter Product Name"
                            />
                        </div>
                        <div className="product-config-page__field">
                            <label className="product-config-page__label" htmlFor="product-code">
                                Product Code
                            </label>
                            <input
                                id="product-code"
                                className="product-config-page__input"
                                name="productCode"
                                value={this.state.productCode}
                                onChange={(e) => {
                                    this.setProductCode(e.target.value)
                                }}
                                placeholder="Enter Product Code"
                            />
                        </div>
                        <div className="product-config-page__field">
                            <label className="product-config-page__label" htmlFor="plan-type">
                                Plan Type
                            </label>
                            <div className="custom-select-container">
                                <select
                                    id="plan-type"
                                    className="product-config-page__select"
                                    onChange={this.handleChange}
                                >{
                                    this.props.productTypeData.productTypeList.map((item) =>
                                        <option key={item.type} value={item.type}>{item.value}</option>)
                                }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="product-config-page__actions">
                        <button
                            type="button"
                            className="product-config-page__btn product-config-page__btn--primary"
                            onClick={this.submitConfig}
                        >
                            Add Product
                        </button>
                    </div>
                </div>

                <div className="proposal-dashboard__table-section product-config-page__table-section">
                {<DataTable
                    convertValueToString={true}
                    cellHeaders={dataElements}
                    data={this.props.productTypeData.productList}
                    keys={dataKeys}
                    addSerialNo={true}
                    showExcelDownload={false}
                    converTdToComponent={"status"}
                    secondconverTdToComponent={"issuanceType"}
                    thirdconverTdToComponent={showUin ? "uin" : undefined}
                    componentToBeConverted={this.setComponent}
                    PerPageApiData={false}
                    paginationItems = {this.props.productTypeData.productList}
                    alwaysShown={false}
                />}
                </div>
            </div>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        productTypeData: state.productTypeData,
        authentication: state.authentication,
    };
};

export default connect(mapStateToProps, {
    getPlanTypeList,
    addProductAction,
    getProductList,
    updateProductStatus,
    updateissuanceType,
    uinSaveHandlerAction
})(ProductConfig);
